import { createApp } from "vue";
import { i18n } from "i18n";
import vui from "vui";
import App from "App";

const el = document.getElementById("booking");

const app = createApp(App, {
	srv: JSON.parse(el.dataset.srv),
	now: Number(el.dataset.now)
});

app.use(i18n);
app.use(vui);

app.mount(el);
